var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main__input", class: "dir__" + _vm.direction },
    [
      _vm.label
        ? _c(
            "label",
            [
              _c("span", {}, [
                _vm._v(_vm._s(_vm.label) + " "),
                _vm.required
                  ? _c("span", { staticClass: "required_mark" }, [_vm._v("*")])
                  : _vm._e()
              ]),
              _vm.hasPopOver
                ? _c("PopOver", _vm._b({}, "PopOver", _vm.popOver, false))
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.multiline
        ? _c("textarea", {
            attrs: {
              type: _vm.type,
              rows: _vm.multiline,
              placeholder: _vm.hint
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              }
            }
          })
        : _c("input", {
            style: _vm.inputStyle,
            attrs: {
              type: _vm.type,
              multiple: "",
              disabled: _vm.disabled,
              autofill: "off",
              autocomplete: _vm.autocomplete,
              placeholder: _vm.hint,
              step: "0.01"
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.value)
              }
            }
          }),
      _vm._v(" "),
      _vm.error ? _c("small", [_vm._v(_vm._s(_vm.error))]) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a12a964", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a12a964","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Input.vue
// module id = null
// module chunks = 